import { render, staticRenderFns } from "./GerenciaGeneralView.vue?vue&type=template&id=c36cefd4"
import script from "./GerenciaGeneralView.vue?vue&type=script&lang=js"
export * from "./GerenciaGeneralView.vue?vue&type=script&lang=js"
import style0 from "./GerenciaGeneralView.vue?vue&type=style&index=0&id=c36cefd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports